export default __webpack_public_path__ + "static/media/banner-home-1.7383e0f6.png";